const VirtualMachine = require('./virtual-machine');

module.exports = VirtualMachine;



//////////////////
// WEBPACK FOOTER
// ./node_modules/scratch-vm/src/index.js
// module id = fKJd
// module chunks = 0